module.exports = __webpack_public_path__ + "img/tth2.d995255f.jpg";